/**************** COLLECTION NAMES ********************/
const COMPANIES = 'COMPANIES';  
const ASSIGNED_PROJECTS = 'ASSIGNED_PROJECTS';  
const CLOSEOUT_SUMMARY = 'CLOSEOUT_SUMMARY';
const DASHBOARD_PROJECTS = 'DASHBOARD_PROJECTS';
const LOCATION_PROJECTS = 'LOCATION_PROJECTS';
const PROJECT_ANALYSIS = 'PROJECT_ANALYSIS';
const MAINTENANCE_PROJECTS = 'MAINTENANCE_PROJECTS';
const PROJECTS_NAV = 'PROJECTS_NAV';
const PROJECTS_ANALYSIS = 'PROJECTS_ANALYSIS';
const PROJECTS_REPORT = 'PROJECTS_REPORT';
const LOCATIONS_NAV = 'LOCATIONS_NAV';
const LOCATION_PROJECTS_NAV = 'LOCATION_PROJECTS_NAV';
const PROJECT_TYPE = 'PROJECT_TYPE';
const EVENT_HISTORIES = 'EVENT_HISTORIES';
const PROJECT_ACTIVITY = 'PROJECT_ACTIVITY';
const USERS = 'USERS';
const COMMENTS = 'COMMENTS';
const COMPLETION_CRITERIA = 'COMPLETION_CRITERIA';
const FAVORITES = 'FAVORITES';
const PROJECTS = 'PROJECTS';
const DUMMIES = 'DUMMIES';
const MARKETS = 'MARKETS';
const CUSTOMERS = 'CUSTOMERS';
const DIRECTORIES = 'DIRECTORIES';
const DIRECTORY = 'DIRECTORY';
const TEAMS = 'TEAMS';
const TEAM = 'TEAM';
const UNREAD_ANNOUNCEMENTS = 'UNREAD_ANNOUNCEMENTS';
const ANNOUNCEMENT = 'ANNOUNCEMENT';
const VENDOR_USERS = 'VENDOR_USERS';
const VENDOR_USER = 'VENDOR_USER';

const MY_PROJECT_TASKS = 'MY_PROJECT_TASKS';
const TASKS_NOT_STARTED = 'TASKS_NOT_STARTED';
const TASKS_IN_PROGRESS = 'TASKS_IN_PROGRESS';
const TASKS_IN_PROGRESS_REJECTED = 'TASKS_IN_PROGRESS_REJECTED';
const TASKS_AWAITING_REVIEW = 'TASKS_AWAITING_REVIEW';
const TASKS_COMPLETED = 'TASKS_COMPLETED';
const USER_ASSIGNED_TASKS = 'USER_ASSIGNED_TASKS';
const USER_PROJECTS = 'USER_PROJECTS';

const MY_PROJECT_TASKS_ACTIVE = 'MY_PROJECT_TASKS_ACTIVE';
const TASKS_NOT_STARTED_ACTIVE = 'TASKS_NOT_STARTED_ACTIVE';
const TASKS_IN_PROGRESS_ACTIVE = 'TASKS_IN_PROGRESS_ACTIVE';
const TASKS_IN_PROGRESS_REJECTED_ACTIVE = 'TASKS_IN_PROGRESS_REJECTED_ACTIVE';
const TASKS_AWAITING_REVIEW_ACTIVE = 'TASKS_AWAITING_REVIEW_ACTIVE';
const TASKS_COMPLETED_ACTIVE = 'TASKS_COMPLETED_ACTIVE';

const PROJECT_INVENTORY_ITEMS = 'PROJECT_INVENTORY_ITEMS';

/** COLLECTION TYPES */ 
// TODO: singularize (for use with denormalize(this.type), etc)
const DUMMY = 'DUMMY';
const CLOSEOUT = 'CLOSEOUT';
const PROJECT = 'PROJECT';
const LOCATION = 'LOCATION';
const COMPANY = 'COMPANY';
const TASK = 'TASK';
const INVENTORY_ITEM = 'INVENTORY_ITEM';
const COMMENT = 'COMMENT';
const COMPLETION_CRITERION = 'COMPLETION_CRITERION';
const FAVORITE = 'FAVORITE';
const LOCATIONS = 'LOCATIONS';
const MARKET = 'MARKET';
const CUSTOMER = 'CUSTOMER';
const EVENT_HISTORY = 'EVENT_HISTORY';
const USER = 'USER';
const VENDORS = 'VENDORS';

export const ItemTypes = {
  Tile: 'tile',
};

/**  
 * PAGE NAMES
 * - used for stateTree.page_states
 */
export const PageNames = {
  MANAGER_DASHBOARD: 'MANAGER_DASHBOARD',
  MOBILE_MAPS: 'MOBILE_MAPS',
  PROJECTS_CONTAINER: 'PROJECTS_CONTAINER',
  MOBILE_PROJECT_DETAIL: 'MOBILE_PROJECT_DETAIL',
};

// Put comments in here for what they mean.
export const RecordStates = {
  NEEDS_SYNC: 'NEEDS_SYNC',
  NEEDS_ATTRIBUTE_SYNC: 'NEEDS_ATTRIBUTE_SYNC',
  SYNCED: 'SYNCED',
  PENDING: 'PENDING',
  DELETED: 'DELETED',
  ERROR: 'ERROR',
};

//Analytics Constants/Keys
export const AnalyticsKeys = {
  TASK_METRICS: 'task_metrics',
  TASK_COUNTS: 'task_counts',
};

export default {
  DUMMIES,
  DUMMY,
  ASSIGNED_PROJECTS,
  PROJECT_ANALYSIS,
  DASHBOARD_PROJECTS,
  LOCATION_PROJECTS,
  MAINTENANCE_PROJECTS,
  PROJECTS_NAV,
  PROJECT_TYPE,
  EVENT_HISTORIES,
  PROJECT_ACTIVITY,
  USERS,
  VENDOR_USERS,
  VENDOR_USER,
  PROJECTS_ANALYSIS,
  PROJECTS_REPORT,
  CLOSEOUT_SUMMARY,
  LOCATION_PROJECTS_NAV,
  MY_PROJECT_TASKS,
  TASKS_NOT_STARTED,
  TASKS_IN_PROGRESS,
  TASKS_IN_PROGRESS_REJECTED,
  TASKS_AWAITING_REVIEW,
  TASKS_COMPLETED,
  USER_ASSIGNED_TASKS,
  USER_PROJECTS,
  MY_PROJECT_TASKS_ACTIVE,
  TASKS_NOT_STARTED_ACTIVE,
  TASKS_IN_PROGRESS_ACTIVE,
  TASKS_IN_PROGRESS_REJECTED_ACTIVE,
  TASKS_AWAITING_REVIEW_ACTIVE,
  TASKS_COMPLETED_ACTIVE,
  PROJECT_INVENTORY_ITEMS,
  CLOSEOUT,
  COMPLETION_CRITERIA,
  COMMENTS,
  PROJECTS,
  LOCATIONS,
  LOCATIONS_NAV,
  LOCATION,
  COMPANY,
  COMPANIES,
  MARKET,
  MARKETS,
  CUSTOMER,
  CUSTOMERS,
  EVENT_HISTORY,
  FAVORITES,
  PROJECT,
  TASK,
  INVENTORY_ITEM,
  COMMENT,
  COMPLETION_CRITERION,
  FAVORITE,
  USER,
  VENDORS,
  DIRECTORIES,
  DIRECTORY,
  TEAM,
  TEAMS,
  ANNOUNCEMENT,
  UNREAD_ANNOUNCEMENTS,
  PageNames,
  RecordStates,
  AnalyticsKeys,
};



// WEBPACK FOOTER //
// ./src/constants/ReduxConstants.js